define('home/views/FeedEmptyView',[
    'backbone-marionette',

    'home/templates/feedEmpty',
], function (
    Marionette,

    feedEmptyTemplate
) {
    'use strict';

    var FeedEmptyView = Marionette.ItemView.extend({
        template: feedEmptyTemplate,
    });

    return FeedEmptyView;
});

